// Callback function to execute when mutations are observed
window.events = window.events || {};
window.events.cognito = window.events.cognito || {};
window.events.cognito.buttonMapped = false;

window.events.cognito.getLabel = function (element) {
    var text = ""
    var _parentNode = element.parentNode;
    if (_parentNode.querySelector('legend.cog-label') != null) {
        text = _parentNode.querySelector('legend.cog-label').innerHTML.replace(/<\/?[^>]+(>|$)/g, "").replace(/ /g, "").replace("\n\t\t\t", "")
        return text;
    }

    return window.events.cognito.getLabel(_parentNode);
}

const callback = (mutationList, observer) => {

    /* kitchen design appointment form start */
    // Select the form elements
    const selectFields = document.querySelectorAll('#cognito-form select');
    const sendToInput = document.querySelector('input[placeholder*="hidden-field Email send to"]');
    const calcInput =  document.querySelector('.cog-html.cog-input pre');

    // Get the last select field
    const lastSelectField = selectFields[selectFields.length - 1];

    if (lastSelectField && lastSelectField.value && calcInput) {
        // Parse the CalculationArray data
        const rules = JSON.parse(calcInput.innerHTML);

        // Find the matching rule based on the selected value
        const matchedRule = rules.find(rule => rule.toLowerCase().includes(lastSelectField.value.toLowerCase()));

        if (matchedRule) {
            // Extract the email and set the value of the send-to input field
            const email = matchedRule.split('=')[1];
            sendToInput.value = email;
            sendToInput.dispatchEvent(new Event("keydown"));
            sendToInput.dispatchEvent(new Event("change"));
        }
    }


    /* kitchen design appointment form end  */


    const submitBtn = document.querySelector('.cog-cognito button[data-action-name]');

    if (submitBtn == null || window.events.cognito.buttonMapped == true) {
        return;
    }

    submitBtn.addEventListener('click', (e) => {
        var buttonName = e.currentTarget.getAttribute("data-action-name")
        var fields = {}
        var index = 1;
        var elementIndex = 1;
        e.currentTarget.closest('form').querySelectorAll("*[type], select").forEach(element => {
            var inputValue = null;
            var label = element.getAttribute('autocomplete') || element.getAttribute('placeholder') || element.getAttribute('title') || "";
            if (label == "") {
                label = window.events.cognito.getLabel(element);
            }

            if (element.getAttribute("type") == "text") {
                inputValue = { type: element.getAttribute('type'), value: element.value, label: label }
            }

            else if (element.getAttribute("type") == "radio" && element.checked == true) {
                inputValue = { type: "radio", value: element.value, label: label }
            }
            else if (element.getAttribute("type") == "checkbox" && element.checked == true) {
                inputValue = { type: "checkbox", value: element.value, label: label }
            }
            else if (element.getAttribute("type") == "date") {
                inputValue = { type: "date", value: element.value, label: label }
            }
            else if (element.querySelectorAll("option").length > 0) {
                inputValue = { type: "select", value: element.querySelector("option:checked").innerHTML, label: "" }
            }

            if (inputValue != null) {
                fields["capture" + elementIndex] = inputValue;
                elementIndex++
            }

        });


        // left for debugging:
        console.log({ event: "cognito form submit", eventData: { "formData": fields, "buttonName": buttonName } });
        var q = setInterval(function () {
            if (document.querySelector('.cog-cognito button[data-action-name]') == null) {
                clearInterval(q);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "cognito form submit", eventData: { "formData": fields, "buttonName": buttonName } });
            }
            index++;

            if (index > 6) {
                clearInterval(q);
            }
        }, 1000);
    })

    window.events.cognito.buttonMapped = true;
};


const observer = new MutationObserver(callback);
observer.observe(document.querySelector('.cognito-embed'), { attributes: true, childList: true, subtree: true });

